// extracted by mini-css-extract-plugin
export var borderRadius = "_bo-4";
export var large = "_bo-3";
export var logoContainer = "_bo-0";
export var nameLogo = "_bo-2";
export var small = "_bo-1";